import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';
import type { CardContentMaxWidth } from '@/lib/types';
import { cleanObject } from '@/lib/util';

import type { CardProps } from '../../types';
import { getDeskTopMaxContentWidth } from '../BaseCardType/helpers';
import { CardContent } from '../CardContent';

import * as S from './StoryType.styles';
export const StoryType = (_props: CardProps) => {
  const props: CardProps = {
    contentAlignment: 'left',
    textAlignment: 'center',
    type: 'default',
    urlType: 'button',
    ...cleanObject(_props),
  };

  const {
    aspectRatio,
    backgroundAlignment,
    className,
    contentMaxWidth,
    isSectionBannerCard = false,
    media,
    mediaWrapperType,
    preload,
    textAlignment,
    type,
    visibleInDesktop,
    visibleInMobile,
    withBackgroundImage = true,
    withWrapperMinHeight = true,
  } = props;
  const deskTopContentMaxWidth = getDeskTopMaxContentWidth(
    type as string,
    contentMaxWidth as CardContentMaxWidth,
  );
  const hasWrapperMinHeight = withWrapperMinHeight;
  return (
    <S.StoryWrapper
      $visibleInDesktop={visibleInDesktop}
      $visibleInMobile={visibleInMobile}
      className={className}
    >
      {withBackgroundImage && media?.image?.url && (
        <S.Media $backgroundAlignment={backgroundAlignment}>
          <MediaWrapper
            {...(media as ContentfulImageWithFocalPointFragment)}
            aspectRatio={aspectRatio}
            data-test-id='BaseCardTypeBackgroundImage'
            mediaWrapperType={mediaWrapperType}
            preload={preload}
            sizes='(max-width: 600px) 50vw, 20vw'
          />
        </S.Media>
      )}
      <S.ContentBox
        data-test-id='BaseCardTypeContent'
        deskTopContentMaxWidth={deskTopContentMaxWidth}
        hasWrapperMinHeight={hasWrapperMinHeight}
        sectionBannerCard={isSectionBannerCard}
        textAlignment={textAlignment}
        type={type}
      >
        <CardContent {...props} />
      </S.ContentBox>
    </S.StoryWrapper>
  );
};
